// extracted by mini-css-extract-plugin
export default {"wrapper-element":"Dashboard_wrapper-element__FOCsG","welcome-card":"Dashboard_welcome-card__dYNBQ","portals":"Dashboard_portals__F4RAi"};